import { hasCapability, type User } from "../base";

export const homeownerSentiment = {
  read: (user: User) => hasCapability(user, "homeownerSentiment.read"),
};
